<template>
<v-navigation-drawer id="appDrawer" :mini-variant.sync="mini" fixed :dark="$vuetify.dark" app v-model="drawer" width="260">
    <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
        <v-list dense expand>
            <v-card color="orange " dark>
                <v-container grid-list-xl>
                    <v-dialog v-model="showDialog" persistent max-width="500px">
                        <v-card>
                            <v-card-text>
                                {{maxTalkClickedMsg}}
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green white--text" text @click="showDialog=false;utils.updateMaxTalkClicked()">
                                    Ok
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-layout row wrap>
                        <v-flex class="avatarimg">
                            <div class="v-avatar-img">
                                <router-link to="/profile">
                                    <img v-if="this.$store.state.user != null" :src="this.$store.state.user.user_profile_pic">
                                </router-link>
                            </div>
                        </v-flex>
                        <v-flex class="avatartext">
                            <router-link to="/profile">
                                <strong >{{user ? utils.shortenLongStrings(user.name, 20) : 'USER'}}</strong>
                            </router-link><br/>
                            <i>
                                <template v-if="user"> 
                                    <template v-if="user.discourse_user_name">
                                        {{user ? ''+utils.shortenLongStrings(user.discourse_user_name, 10)+'': '' }}
                                        <br/>
                                    </template>
                                </template>
                            </i>
                            <i>{{ user ? user.email : ''}}</i><br/>
                            <i>{{ user ? user.company_address : ''}}</i><br/>
                        </v-flex>
                        <v-list class="pa-0">
                            <v-list-tile class="paddingZero">
                            </v-list-tile>
                        </v-list>
                    </v-layout>
                </v-container>
            </v-card>
            <template v-if="user && !user.isImr" v-for="(item, i) in menus">
                <v-list-group v-if="item.items" :key="i" :group="item.group" :prepend-icon="item.icon" no-action="no-action" :class="shouldShowHdr(item.items) ? '': 'hidden-lg-and-down'" @click="showDialogFn(item.title)">
                    <v-list-tile slot="activator" ripple="ripple">
                        <v-list-tile-content>
                            <v-list-tile-title>
                                {{item.title}}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <template v-for="(subItem, i) in item.items">
                        <v-list-group v-if="subItem.items" :key="i" :group="subItem.group" sub-group="sub-group">
                            <v-list-tile slot="activator" ripple="ripple">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list-group>
                        <div v-else :key="i">
                            <v-list-tile v-if="checkPermission(subItem) && subItem.forSuperAdmin && user && user.Issuperadmin" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                                <v-list-tile-content>
                                    <v-list-tile-title><span>{{ subItem.title }}</span></v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action v-if="subItem.action">
                                    <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile v-if="checkPermission(subItem) && !subItem.forSuperAdmin" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                                <v-list-tile-content>
                                    <v-list-tile-title><span>{{ subItem.title }} </span></v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action v-if="subItem.action">
                                    <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </div>
                    </template>
                </v-list-group>
                <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
                <v-divider v-else-if="item.divider" :key="i"></v-divider>
                <v-list-tile v-else-if="checkPermission(item) && item.forSuperAdmin && user && user.Issuperadmin" :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="i">
                    <v-list-tile-action v-if="item.icon">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-else-if="checkPermission(item) && !item.forSuperAdmin" :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="i">
                    <v-list-tile-action v-if="item.icon">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="item.subAction">
                        <v-icon class="success--text">{{ item.subAction }}</v-icon>
                    </v-list-tile-action>
                </v-list-tile>
            </template>

            <template v-if="user && user.isImr" v-for="(item, i) in imrMenu">
                <v-list-group v-if="item.items" :key="i" :group="item.group" :prepend-icon="item.icon" no-action="no-action" :class="shouldShowHdr(item.items) ? '': 'hidden-lg-and-down'" @click="showDialogFn(item.title)">
                    <v-list-tile slot="activator" ripple="ripple">
                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <template v-for="(subItem, i) in item.items">
                        <v-list-group v-if="subItem.items" :key="i" :group="subItem.group" sub-group="sub-group">
                            <v-list-tile slot="activator" ripple="ripple">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list-group>
                        <div v-else :key="i">
                            <v-list-tile v-if="checkPermission(subItem) && subItem.forSuperAdmin && user && user.Issuperadmin" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                                <v-list-tile-content>
                                    <v-list-tile-title><span>{{ subItem.title }}</span></v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action v-if="subItem.action">
                                    <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile v-if="checkPermission(subItem) && !subItem.forSuperAdmin" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                                <v-list-tile-content>
                                    <v-list-tile-title><span>{{ subItem.title }} </span></v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action v-if="subItem.action">
                                    <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </div>
                    </template>
                </v-list-group>
                <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
                <v-divider v-else-if="item.divider" :key="i"></v-divider>
                <v-list-tile v-else-if="checkPermission(item) && item.forSuperAdmin && user && user.Issuperadmin" :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="i">
                    <v-list-tile-action v-if="item.icon">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-else-if="checkPermission(item) && !item.forSuperAdmin" :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="i">
                    <v-list-tile-action v-if="item.icon">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="item.subAction">
                        <v-icon class="success--text">{{ item.subAction }}</v-icon>
                    </v-list-tile-action>
                </v-list-tile>
            </template>
        </v-list>
    </vue-perfect-scrollbar>
</v-navigation-drawer>
</template>

<script>
import menu from "@/api/menu";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import config from "../config";
import utils from "../util/";
export default {
    name: "app-drawer",
    components: {
        VuePerfectScrollbar
    },
    props: {
        expanded: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        onlyForSuperAdmin:['CHATBOT','BULK EMAIL'],
        test:false,
        mini: false,
        drawer: true,
        user: null,
        menus: menu.Menu,
        imrMenu: menu.imrMenu,
        scrollSettings: {
            maxScrollbarLength: 200
        },
        maxTalkClickedMsg:config.maxTalkClickedMsg,
        showDialog:false
    }),
    computed: {
        computeGroupActive() {
            return true;
        },
        computeLogo() {
            return "/static/m.png";
        },

        sideToolbarColor() {
            return this.$vuetify.options.extra.sideNav;
        }

    },
    mounted() {
        if (this.$store.state.user) {
            this.user = this.$store.state.user;
            console.log(this.user)
        }
    },
    created() {
        window.getApp.$on("APP_DRAWER_TOGGLED", () => {
            this.drawer = !this.drawer;
        });
        window.getApp.$on("APP_DRAWER_MINIMIZED", () => {
            this.mini = !this.mini;
        });
        this.utils = utils;
    },
    methods: {
        shouldShowHdr(data) {
            let allowedItems = 0;
            for (let i = 0; i < data.length; i++) {
                if (this.checkPermission(data[i])) {
                    allowedItems += 1;
                }
            }
            return allowedItems > 0;
        },
        genChildTarget(item, subItem) {
            if (subItem.href) return;
            if (subItem.component) {
                return {
                    name: subItem.component
                };
            }
            return {
                name: `${item.group}/${subItem.name}`
            };
        },
        checkPermission(data) {
            if (!data.is_module) {
                return true;
            }
            let show = false;
            if (this.user) {
                const perm = this.user.permissions[data.slug];
                if(perm === undefined){
                    show = false;
                } else {
                    if(data.forAddEdit !== undefined && data.forAddEdit && perm === 'all'){
                        show = true;
                    } else if(!data.forAddEdit && (perm==='all' || perm==='view')){
                        show = true;
                    }
                }
            }
            return show;
        },
        showDialogFn(itemTitle){
            const self = this;
            if(itemTitle == "COMMUNITY" && self.$store.state.user.is_maxtalk_clicked == 0 && !self.$store.state.user.Issuperadmin){
                self.showDialog = true;
            }else{
                self.showDialog = false;
            }
        }
    }
};
</script>

<style lang="stylus">
// @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';

#appDrawer
  overflow: hidden
.drawer-menu--scroll
    height: calc(100vh - 120px)
    overflow: auto
.v-avatar-img img
    width: 100%;
    border-radius: 100%;    
.app--toolbar.v-toolbar 
    z-index:3;
    padding-left: 0 !important;
.app--drawer.v-navigation-drawer
    padding-top: 63px;
.v-input__prepend-outer
    margin-left: 0;
section .v-list--dense
    padding-top:0px !important;
.avatartext strong {text-transform: capitalize;}    
</style>



// WEBPACK FOOTER //
// src/components/AppDrawer.vue